"use strict";

require("./index");

require("./core");

require("./es2015");

require("./flow");

require("./jsx");

require("./misc");

require("./experimental");


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/lib/types/definitions/init.js
// module id = 2159
// module chunks = 0